<template>
  <div class="page-index" :style="{backgroundImage: 'url(' + assets.img.background + ')'}">
    
    <div class="perspective" :class="{'perspective-anim-1':anim.one.active}">
      <div class="perspective-inner">
        <a class="link-3D shows" href="#/shows"><i class="fa fa-calendar"></i> Shows &amp; Archives</a>
        <br>
        <a class="link-3D listen" href="#/shows" @click="Creek.audio.live.play()"><i class="fa fa-play"></i> Listen Live</a>
        <br>
        <a class="link-3D info" href="#/about"><i class="fa fa-info-circle"></i> Info</a>
      </div>
    </div>

  </div>
</template>

<script type="text/javascript">
import Images_Background from "../assets/img/background-1.jpg";
export default {
  name: "page-index",
  data () { 
    return { 
      assets: {
        img: {
          // logo: Images_Logo,
          background: Images_Background
        }
      },
      anim: {
        one: {
          time: 1000,
          active: false
          // active: false
        }
      }
    } 
  },
  created () {

    var _this = this;

    var animOne = function(){
      _this.anim.one.active = true;
    }
      // alert(1);
    // animOne();
    var anim1 = setTimeout(animOne, 1);
    // var anim1 = setTimeout(1000, function(){ animOne() });
    // setTimeout(function(){ animOne }, 1000);
  },
  methods: { 
  
  }
}
</script>